import {
  GET_CONTACT_ESTIMATE_REQUEST,
  GET_CONTACT_ESTIMATE_SUCCESS,
  GET_CONTACT_ESTIMATE_FAILURE,
  RESET_CONTACT,
  statusType
} from '../../../../actions'

const initial = {
  data: [],
  status: statusType.IDLE
}

const estimate = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_CONTACT_ESTIMATE_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_ESTIMATE_SUCCESS:
      return {
        ...state,
        data: (payload || []).sort((a, b) => new Date(b.date) - new Date(a.date)),
        status: statusType.SUCCESS
      }

    case GET_CONTACT_ESTIMATE_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case RESET_CONTACT:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default estimate
